import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
    {
        path: '/',
        name: 'Home',
        meta: {
            layout: 'default'
        },
        component: Home
    },
    {
        path: '/:pathMatch(.*)*',
        component: () => import(/* webpackChunkName: "about" */ 'COMPONENTS/Page404.vue')
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router